'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends5 = require('babel-runtime/helpers/extends');

var _extends6 = _interopRequireDefault(_extends5);

var _findIndex3 = require('lodash/findIndex');

var _findIndex4 = _interopRequireDefault(_findIndex3);

var _reject3 = require('lodash/reject');

var _reject4 = _interopRequireDefault(_reject3);

var _get3 = require('lodash/get');

var _get4 = _interopRequireDefault(_get3);

exports.default = reducer;
exports.init = init;
exports.initProject = initProject;
exports.initSubmittedFiles = initSubmittedFiles;
exports.initSubmittedReplaceFile = initSubmittedReplaceFile;
exports.isLoaded = isLoaded;
exports.isLoadProjectTime = isLoadProjectTime;
exports.loadProject = loadProject;
exports.saveProject = saveProject;
exports.publish = publish;
exports.publishSharespace = publishSharespace;
exports.stopPublish = stopPublish;
exports.submitMediaFile = submitMediaFile;
exports.submitCloudFile = submitCloudFile;
exports.deleteMediaFile = deleteMediaFile;
exports.submitMediaReplaceFile = submitMediaReplaceFile;
exports.submitPressFile = submitPressFile;
exports.deletePressFile = deletePressFile;
exports.toggleEmailWysiwyg = toggleEmailWysiwyg;
exports.saveEmail = saveEmail;
exports.loadRecipientsList = loadRecipientsList;
exports.copyProject = copyProject;
exports.loadCommon = loadCommon;
exports.loadMediaList = loadMediaList;
exports.loadPressList = loadPressList;
exports.deleteMedia = deleteMedia;
exports.deleteCloudFile = deleteCloudFile;
exports.deletePress = deletePress;
exports.editMedia = editMedia;
exports.addMedia = addMedia;
exports.addFailedMedia = addFailedMedia;
exports.addPress = addPress;
exports.replaceMedia = replaceMedia;
exports.addRecipient = addRecipient;
exports.addRecipients = addRecipients;
exports.deleteRecipient = deleteRecipient;
exports.deleteRecipientsGroup = deleteRecipientsGroup;
exports.clearRecipientsList = clearRecipientsList;
exports.editProjectLinks = editProjectLinks;
exports.deleteCover = deleteCover;
exports.setCover = setCover;
exports.testEmail = testEmail;
exports.sendEmail = sendEmail;
exports.loadConfirmation = loadConfirmation;
exports.loadStatusInfo = loadStatusInfo;
exports.updateCoverStyle = updateCoverStyle;
exports.addRecipientsFromContacts = addRecipientsFromContacts;
exports.addRecipientsFromGroups = addRecipientsFromGroups;
exports.setMultipleBoxsets = setMultipleBoxsets;
exports.editRecipient = editRecipient;
exports.loadTeamMembers = loadTeamMembers;
exports.editTeamMember = editTeamMember;
exports.deleteTeamMember = deleteTeamMember;
exports.loadUsersList = loadUsersList;
exports.addTeamMember = addTeamMember;
exports.loadSSProjects = loadSSProjects;
exports.deleteSSProject = deleteSSProject;
exports.canSuspendSharespace = canSuspendSharespace;
exports.canPublishSharespace = canPublishSharespace;
exports.suspendSharespace = suspendSharespace;
exports.createSubproject = createSubproject;
exports.updateMediaOrder = updateMediaOrder;
exports.ssCreate = ssCreate;
exports.projectCreate = projectCreate;
exports.addSender = addSender;
exports.deleteSender = deleteSender;
exports.setRecipientsDownload = setRecipientsDownload;
exports.resortMediaList = resortMediaList;
exports.setCloudFileStatus = setCloudFileStatus;
exports.setCloudFileFailedStatus = setCloudFileFailedStatus;
exports.setCloudFileSuccessStatus = setCloudFileSuccessStatus;
exports.setCloudFileMetadata = setCloudFileMetadata;

var _loadReducer = require('../loadReducer');

var _loadReducer2 = _interopRequireDefault(_loadReducer);

var _utils = require('helpers/utils');

var _update = require('react/lib/update');

var _update2 = _interopRequireDefault(_update);

var _qim = require('qim');

var qim = _interopRequireWildcard(_qim);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Project redux reducer and action creators */

var INIT = 'project/INIT';
var INIT_PROJECT = 'project/INIT_PROJECT';
var INIT_SUBMITTED_FILES = 'project/INIT_SUBMITTED_FILES';
var INIT_SUBMITTED_REPLACE_FILE = 'project/INIT_SUBMITTED_REPLACE_FILE';
var SUBMIT_MEDIA_FILE = 'project/SUBMIT_MEDIA_FILE';
var DELETE_MEDIA_FILE = 'project/DELETE_MEDIA_FILE';
var SUBMIT_MEDIA_REPLACE_FILE = 'project/SUBMIT_MEDIA_REPLACE_FILE';
var SUBMIT_PRESS_FILE = 'project/SUBMIT_PRESS_FILE';
var DELETE_PRESS_FILE = 'project/DELETE_PRESS_FILE';
var UPDATE = 'project/UPDATE';
var TOGGLE_EMAIL_WYSIWYG = 'project/TOGGLE_EMAIL_WYSIWYG';
var ADD_MEDIA = 'project/ADD_MEDIA';
var ADD_FAILED_MEDIA = 'project/ADD_FAILED_MEDIA';
var ADD_PRESS = 'project/ADD_PRESS';
var REPLACE_MEDIA = 'project/REPLACE_MEDIA';
var ADD_RECIPIENTS = 'project/ADD_RECIPIENTS';
var SET_COVER = 'project/SET_COVER';
var EDIT_RECIPIENT = 'project/EDIT_RECIPIENT';
var EDIT_RECIPIENT_SUCCESS = 'project/EDIT_RECIPIENT_SUCCESS';
var EDIT_RECIPIENT_FAIL = 'project/EDIT_RECIPIENT_FAIL';
var RESORT_MEDIA_LIST = 'project/RESORT_MEDIA_LIST';
var SUBMIT_CLOUD_FILE = 'project/SUBMIT_CLOUD_FILE';
var SET_CLOUD_FILE_DATA = 'project/SET_CLOUD_FILE_DATA';
var CLEAR_RECIPIENTS_LIST = 'project/CLEAR_RECIPIENTS_LIST';

var loadReducer = (0, _loadReducer2.default)('project', {
  project: { action: 'load', init: null, field: ['project'] },
  common: { action: 'load', init: {} },
  copyProject: { init: null },
  recipientsList: { action: 'load', init: [] },
  saveProject: {},
  mediaList: { action: 'load', init: [] },
  deleteMedia: {},
  deleteCloudFile: {},
  editMedia: {},
  pressList: { action: 'load', init: [] },
  deletePress: {},
  addRecipient: {},
  deleteRecipient: {},
  deleteRecipientsGroup: {},
  saveEmail: {},
  editLinks: {},
  deleteCover: {},
  testEmail: {},
  sendEmail: {},
  confirmation: { action: 'load', init: {} },
  statusInfo: { action: 'load', init: {} },
  publish: {},
  publishSharespace: {},
  stopPublish: {},
  updateCoverStyle: {},
  addRecipientsFromContacts: {},
  addRecipientsFromGroups: {},
  setMultipleBoxsets: {},
  teamMembersList: { action: 'load', init: [] },
  editTeamMember: {},
  deleteTeamMember: {},
  usersList: { action: 'load', init: [] },
  suggestionList: { action: 'load', init: { contacts: [] } },
  addTeamMember: {},
  ssProjectsList: { action: 'load', init: [] },
  deleteSSProject: {},
  canSuspendSharespace: {},
  canPublishSharespace: {},
  suspendSharespace: {},
  createSubproject: {},
  updateMediaOrder: {},
  ssCreate: {},
  projectCreate: {},
  addSender: {},
  deleteSender: {},
  setRecipientsDownload: {}
});

var initialState = (0, _extends6.default)({}, loadReducer.initialState, {
  submittedMediaFiles: [],
  submittedCloudFiles: [],
  submittedPressFiles: [],
  submittedMediaReplaceFile: [],
  mediaFailedListData: [],
  showEmailWysiwyg: false,
  loadingEditRecipient: {}
});

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case 'RESET':
      return initialState;
    case INIT:
      return (0, _extends6.default)({}, initialState);
    case INIT_PROJECT:
      return (0, _extends6.default)({}, state, {
        projectData: {},
        projectActionData: {},
        projectLoaded: false,
        teamMembersListData: [],
        recipientsListData: [],
        mediaListData: []
      });
    case INIT_SUBMITTED_FILES:
      return (0, _extends6.default)({}, state, {
        submittedMediaFiles: [],
        submittedPressFiles: [],
        submittedMediaReplaceFile: [],
        submittedCloudFiles: [],
        mediaFailedListData: []
      });
    case INIT_SUBMITTED_REPLACE_FILE:
      return (0, _extends6.default)({}, state, {
        submittedMediaReplaceFile: []
      });
    case loadReducer.constants.LOAD_PROJECT:
      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
        submittedMediaFiles: [],
        submittedPressFiles: [],
        submittedMediaReplaceFile: [],
        mediaFailedListData: [],
        publishLoaded: false,
        publishSharespaceLoaded: false,
        stopPublishLoaded: false,
        suspendSharespaceLoaded: false
      });
    case loadReducer.constants.SAVE_PROJECT_SUCCESS:
      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
        projectData: (0, _extends6.default)({}, state.projectData, action.projectData, action.result.data)
      });
    case loadReducer.constants.EDIT_LINKS_SUCCESS:
      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
        projectData: (0, _extends6.default)({}, state.projectData, action.result.data)
      });
    case SUBMIT_MEDIA_FILE:
      return (0, _extends6.default)({}, state, {
        submittedMediaFiles: [].concat((0, _toConsumableArray3.default)(state.submittedMediaFiles), [action.fileId])
      });
    case SUBMIT_CLOUD_FILE:
      return (0, _extends6.default)({}, state, {
        submittedCloudFiles: [].concat((0, _toConsumableArray3.default)(state.submittedCloudFiles), [action.file])
      });
    case DELETE_MEDIA_FILE:
      return (0, _extends6.default)({}, state, {
        submittedMediaFiles: state.submittedMediaFiles.filter(function (item) {
          return action.fileId !== item;
        })
      });
    case SUBMIT_MEDIA_REPLACE_FILE:
      return (0, _extends6.default)({}, state, {
        submittedMediaReplaceFile: [action.fileId]
      });
    case SUBMIT_PRESS_FILE:
      return (0, _extends6.default)({}, state, {
        submittedPressFiles: [].concat((0, _toConsumableArray3.default)(state.submittedPressFiles), [action.fileId])
      });
    case DELETE_PRESS_FILE:
      return (0, _extends6.default)({}, state, {
        submittedPressFiles: state.submittedPressFiles.filter(function (item) {
          return action.fileId !== item;
        })
      });
    case UPDATE:
      return (0, _extends6.default)({}, state, {
        projectData: action.project
      });
    case TOGGLE_EMAIL_WYSIWYG:
      return (0, _extends6.default)({}, state, {
        showEmailWysiwyg: !state.showEmailWysiwyg
      });
    case loadReducer.constants.SAVE_EMAIL_SUCCESS:
      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
        projectData: (0, _extends6.default)({}, state.projectData, action.result.data),
        showEmailWysiwyg: false
      });
    case loadReducer.constants.DELETE_MEDIA_SUCCESS:
      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
        mediaListData: (0, _reject4.default)(state.mediaListData, { id: action.uploadId }),
        submittedMediaFiles: state.submittedMediaFiles.filter(function (item) {
          return action.uploaderId !== item;
        })
      });
    case loadReducer.constants.DELETE_CLOUD_FILE_SUCCESS:
      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
        mediaListData: (0, _reject4.default)(state.mediaListData, { id: action.uploadId }),
        submittedCloudFiles: state.submittedCloudFiles.filter(function (item) {
          return action.uploadId !== (0, _get4.default)(item, 'metadata.id');
        })
      });
    case loadReducer.constants.EDIT_MEDIA_SUCCESS:
      {
        var editedIndex = (0, _findIndex4.default)(state.mediaListData, function (mediaItem) {
          return mediaItem.id === action.uploadId;
        });
        var mediaListData = [].concat((0, _toConsumableArray3.default)(state.mediaListData));
        mediaListData[editedIndex] = (0, _get4.default)(action, 'result.data.media[0]');
        return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
          mediaListData: mediaListData
        });
      }
    case ADD_MEDIA:
      return (0, _extends6.default)({}, state, {
        mediaListData: [].concat((0, _toConsumableArray3.default)(state.mediaListData), [action.media])
      });
    case ADD_FAILED_MEDIA:
      return (0, _extends6.default)({}, state, {
        mediaFailedListData: [].concat((0, _toConsumableArray3.default)(state.mediaFailedListData), [action.media])
      });
    case REPLACE_MEDIA:
      {
        var replacedIndex = (0, _findIndex4.default)(state.mediaListData, function (mediaItem) {
          return mediaItem.id === action.oldMediaId;
        });
        var _mediaListData = [].concat((0, _toConsumableArray3.default)(state.mediaListData));
        _mediaListData[replacedIndex] = action.media;
        return (0, _extends6.default)({}, state, {
          mediaListData: _mediaListData
        });
      }
    case loadReducer.constants.DELETE_PRESS_SUCCESS:
      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
        pressListData: (0, _reject4.default)(state.pressListData, { pressId: action.pressId })
      });
    case loadReducer.constants.ADD_RECIPIENT_SUCCESS:
      {
        var respCode = (0, _get4.default)(action, 'result.code');
        var newRecipientsListData = [].concat((0, _toConsumableArray3.default)(state.recipientsListData));
        var _editedIndex = -1;

        if (respCode === 201) {
          _editedIndex = (0, _findIndex4.default)(state.recipientsListData, function (recipient) {
            return recipient.recipientId === action.result.data.recipientId;
          });
        }
        if (_editedIndex > -1) {
          newRecipientsListData[_editedIndex] = (0, _get4.default)(action, 'result.data');
        } else {
          newRecipientsListData.push((0, _get4.default)(action, 'result.data'));
        }

        return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
          recipientsListData: newRecipientsListData
        });
      }
    case loadReducer.constants.DELETE_RECIPIENT_SUCCESS:
      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
        recipientsListData: (0, _reject4.default)(state.recipientsListData, { recipientId: action.recipientId })
      });
    case loadReducer.constants.DELETE_RECIPIENTS_GROUP_SUCCESS:
      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
        recipientsListData: (0, _reject4.default)(state.recipientsListData, { groupId: action.groupId })
      });
    case ADD_PRESS:
      return (0, _extends6.default)({}, state, {
        pressListData: [].concat((0, _toConsumableArray3.default)(state.pressListData), [action.press])
      });
    case ADD_RECIPIENTS:
      {
        var recipients = action.recipients.filter(function (recipient) {
          return !recipient.result;
        });
        return (0, _extends6.default)({}, state, {
          recipientsListData: [].concat((0, _toConsumableArray3.default)((0, _utils.mergeObjectArraysByKey)('recipientId', state.recipientsListData, recipients)))
        });
      }
    case CLEAR_RECIPIENTS_LIST:
      return (0, _extends6.default)({}, state, {
        recipientsListData: []
      });
    /*case loadReducer.constants.ADD_RECIPIENTS_FROM_CONTACTS_SUCCESS:
      return {
        ...loadReducer.reducer(state, action),
        recipientsListData: [...mergeObjectArraysByKey('recipientId', state.recipientsListData, action.result.data)]
      };*/
    case loadReducer.constants.DELETE_COVER_SUCCESS:
      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
        projectData: (0, _extends6.default)({}, state.projectData, {
          imageThumb: ''
        })
      });
    case loadReducer.constants.UPDATE_COVER_STYLE_SUCCESS:
      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
        projectData: (0, _extends6.default)({}, state.projectData, {
          coverStyle: action.coverStyle
        })
      });
    case SET_COVER:
      return (0, _extends6.default)({}, state, {
        projectData: (0, _extends6.default)({}, state.projectData, {
          imageThumb: action.cover
        })
      });
    case loadReducer.constants.SET_MULTIPLE_BOXSETS_SUCCESS:
      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
        projectData: (0, _extends6.default)({}, state.projectData, {
          multipleBoxsets: action.multipleBoxsets
        })
      });
    case EDIT_RECIPIENT:
      return (0, _extends6.default)({}, state, {
        loadingEditRecipient: (0, _extends6.default)({}, state.loadingEditRecipient, (0, _defineProperty3.default)({}, action.recipientId, true))
      });
    case EDIT_RECIPIENT_SUCCESS:
      return (0, _extends6.default)({}, state, {
        recipientsListData: [].concat((0, _toConsumableArray3.default)((0, _utils.mergeObjectArraysByKey)('recipientId', state.recipientsListData, [action.result.data]))),
        loadingEditRecipient: (0, _extends6.default)({}, state.loadingEditRecipient, (0, _defineProperty3.default)({}, action.recipientId, false))
      });
    case EDIT_RECIPIENT_FAIL:
      return (0, _extends6.default)({}, state, {
        loadingEditRecipient: (0, _extends6.default)({}, state.loadingEditRecipient, (0, _defineProperty3.default)({}, action.recipientId, false))
      });
    case loadReducer.constants.EDIT_TEAM_MEMBER_SUCCESS:
      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
        teamMembersListData: [].concat((0, _toConsumableArray3.default)((0, _utils.mergeObjectArraysByKey)('shareeId', state.teamMembersListData, action.result.data)))
      });
    case loadReducer.constants.DELETE_TEAM_MEMBER_SUCCESS:
      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
        teamMembersListData: (0, _reject4.default)(state.teamMembersListData, { shareeId: action.shareeId })
      });
    case loadReducer.constants.ADD_TEAM_MEMBER_SUCCESS:
      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
        teamMembersListData: [].concat((0, _toConsumableArray3.default)((0, _utils.mergeObjectArraysByKey)('shareeId', state.teamMembersListData, action.result.data)))
      });
    case loadReducer.constants.DELETE_S_S_PROJECT_SUCCESS:
      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
        ssProjectsListData: (0, _reject4.default)(state.ssProjectsListData, { id: action.projectId })
      });
    case loadReducer.constants.SUSPEND_SHARESPACE_SUCCESS:
      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
        publishLoaded: false,
        publishSharespaceLoaded: false
      });
    case loadReducer.constants.LOAD_CONFIRMATION_SUCCESS:
      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
        publishLoaded: false
      });
    case loadReducer.constants.PUBLISH_SHARESPACE_SUCCESS:
      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
        suspendSharespaceLoaded: false
      });
    case loadReducer.constants.SS_CREATE:
      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
        ssCreateData: null
      });
    case loadReducer.constants.PROJECT_CREATE:
      return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
        projectCreateData: null
      });
    case loadReducer.constants.SET_RECIPIENTS_DOWNLOAD_SUCCESS:
      {
        return qim.update([['recipientsListData', qim.$each, 'download', qim.$set(Number(action.download))]], loadReducer.reducer(state, action));
      }
    case RESORT_MEDIA_LIST:
      {
        var dragItem = state.mediaListData[action.dragIndex];
        return (0, _extends6.default)({}, state, {
          mediaListData: (0, _update2.default)(state.mediaListData, {
            $splice: [[action.dragIndex, 1], [action.hoverIndex, 0, dragItem]]
          })
        });
      }
    case SET_CLOUD_FILE_DATA:
      {
        var editedCloudFileIndex = (0, _findIndex4.default)(state.submittedCloudFiles, function (cloudFile) {
          return cloudFile.uniqId === action.uniqId;
        });
        var submittedCloudFiles = [].concat((0, _toConsumableArray3.default)(state.submittedCloudFiles));
        if (editedCloudFileIndex > -1) {
          submittedCloudFiles[editedCloudFileIndex] = (0, _extends6.default)({}, submittedCloudFiles[editedCloudFileIndex], action.data);
        }
        return (0, _extends6.default)({}, loadReducer.reducer(state, action), {
          submittedCloudFiles: submittedCloudFiles
        });
      }
    default:
      return loadReducer.reducer(state, action);
  }
}

function init() {
  return {
    type: INIT
  };
}

function initProject() {
  return {
    type: INIT_PROJECT
  };
}

function initSubmittedFiles() {
  return {
    type: INIT_SUBMITTED_FILES
  };
}

function initSubmittedReplaceFile() {
  return {
    type: INIT_SUBMITTED_REPLACE_FILE
  };
}

function isLoaded(id, globalState) {
  var loadedProjectId = (0, _get4.default)(globalState, 'project.projectActionData.projectId');
  return (0, _get4.default)(globalState, 'project.projectLoaded', false) && id === loadedProjectId;
}

function isLoadProjectTime(id, globalState) {
  return (/*!isLoaded(id, globalState) && */(0, _get4.default)(globalState, 'auth.user', false)
  );
}

function loadProject(projectId) {
  return {
    types: loadReducer.constantsByKey.project,
    promise: function promise(client) {
      return client.post('project_wa/getProject', { data: { projectId: projectId } });
    },
    projectId: Number(projectId)
  };
}

function saveProject(projectData) {
  var endpoint = projectData.projectId ? 'project_wa/editProject' : 'project_wa/addProject';
  return {
    types: loadReducer.constantsByKey.saveProject,
    promise: function promise(client) {
      return client.post(endpoint, { data: (0, _extends6.default)({}, projectData) });
    },
    projectData: projectData
  };
}

function publish(projectId) {
  return {
    types: loadReducer.constantsByKey.publish,
    promise: function promise(client) {
      return client.post('project_wa/publish', { data: { projectId: projectId } });
    },
    projectId: projectId
  };
}

function publishSharespace(projectId) {
  return {
    types: loadReducer.constantsByKey.publishSharespace,
    promise: function promise(client) {
      return client.post('project_wa/publishSharespace', { data: { projectId: projectId } });
    },
    projectId: projectId
  };
}

function stopPublish(projectId) {
  return {
    types: loadReducer.constantsByKey.stopPublish,
    promise: function promise(client) {
      return client.post('project_wa/stopPublish', { data: { projectId: projectId } });
    },
    projectId: projectId
  };
}

function submitMediaFile(fileId) {
  return {
    type: SUBMIT_MEDIA_FILE,
    fileId: fileId
  };
}

function submitCloudFile(file) {
  return {
    type: SUBMIT_CLOUD_FILE,
    file: file
  };
}

function deleteMediaFile(fileId) {
  return {
    type: DELETE_MEDIA_FILE,
    fileId: fileId
  };
}

function submitMediaReplaceFile(fileId) {
  return {
    type: SUBMIT_MEDIA_REPLACE_FILE,
    fileId: fileId
  };
}

function submitPressFile(fileId) {
  return {
    type: SUBMIT_PRESS_FILE,
    fileId: fileId
  };
}

function deletePressFile(fileId) {
  return {
    type: DELETE_PRESS_FILE,
    fileId: fileId
  };
}

function toggleEmailWysiwyg() {
  return {
    type: TOGGLE_EMAIL_WYSIWYG
  };
}

function saveEmail(projectId, data) {
  return (0, _extends6.default)({
    types: loadReducer.constantsByKey.saveEmail,
    promise: function promise(client) {
      return client.post('project_wa/editEmailTemplate', { data: (0, _extends6.default)({ projectId: projectId }, data) });
    },
    projectId: projectId
  }, data);
}

function loadRecipientsList(projectId) {
  return {
    types: loadReducer.constantsByKey.recipientsList,
    promise: function promise(client) {
      return client.post('project_wa/getRecipientList', { data: { projectId: projectId } });
    },
    projectId: projectId
  };
}

function copyProject(projectId) {
  return {
    types: loadReducer.constantsByKey.copyProject,
    promise: function promise(client) {
      return client.post('project_wa/copyProject', { data: { projectId: projectId } });
    },
    projectId: projectId
  };
}

function loadCommon() {
  return {
    types: loadReducer.constantsByKey.common,
    promise: function promise(client) {
      return client.post('project_wa/getCommonData');
    }
  };
}

function loadMediaList(projectId) {
  return {
    types: loadReducer.constantsByKey.mediaList,
    promise: function promise(client) {
      return client.post('project_wa/getAudioList', { data: { projectId: projectId } });
    },
    projectId: projectId
  };
}

function loadPressList(projectId) {
  return {
    types: loadReducer.constantsByKey.pressList,
    promise: function promise(client) {
      return client.post('project_wa/getPressList', { data: { projectId: projectId } });
    },
    projectId: projectId
  };
}

function deleteMedia(projectId, uploadId, uploaderId) {
  return {
    types: loadReducer.constantsByKey.deleteMedia,
    promise: function promise(client) {
      return client.post('project_wa/deleteMedia', { data: { projectId: projectId, uploadId: uploadId } });
    },
    projectId: projectId,
    uploadId: uploadId,
    uploaderId: uploaderId
  };
}

function deleteCloudFile(projectId, uploadId) {
  return {
    types: loadReducer.constantsByKey.deleteCloudFile,
    promise: function promise(client) {
      return client.post('project_wa/deleteMedia', { data: { projectId: projectId, uploadId: uploadId } });
    },
    projectId: projectId,
    uploadId: uploadId
  };
}

function deletePress(projectId, pressId) {
  return {
    types: loadReducer.constantsByKey.deletePress,
    promise: function promise(client) {
      return client.post('project_wa/deletePress', { data: { projectId: projectId, pressId: pressId } });
    },
    projectId: projectId,
    pressId: pressId
  };
}

function editMedia(projectId, uploadId, data) {
  return {
    types: loadReducer.constantsByKey.editMedia,
    promise: function promise(client) {
      return client.post('project_wa/editMedia', { data: (0, _extends6.default)({ projectId: projectId, uploadId: uploadId }, data) });
    },
    projectId: projectId,
    uploadId: uploadId
  };
}

function addMedia(media, projectId) {
  return {
    type: ADD_MEDIA,
    media: media,
    projectId: projectId
  };
}

function addFailedMedia(media, projectId) {
  return {
    type: ADD_FAILED_MEDIA,
    media: media,
    projectId: projectId
  };
}

function addPress(press, projectId) {
  return {
    type: ADD_PRESS,
    press: press,
    projectId: projectId
  };
}

function replaceMedia(media, projectId, oldMediaId) {
  return {
    type: REPLACE_MEDIA,
    media: media,
    projectId: projectId,
    oldMediaId: oldMediaId
  };
}

function addRecipient(projectId, data) {
  return (0, _extends6.default)({
    types: loadReducer.constantsByKey.addRecipient,
    promise: function promise(client) {
      return client.post('project_wa/addRecipientFromEmail', { data: (0, _extends6.default)({ projectId: projectId }, data), successCodes: [201] });
    }
  }, data, {
    projectId: projectId
  });
}

function addRecipients(projectId, recipients) {
  return {
    type: ADD_RECIPIENTS,
    projectId: projectId,
    recipients: recipients
  };
}

function deleteRecipient(projectId, recipientId) {
  return {
    types: loadReducer.constantsByKey.deleteRecipient,
    promise: function promise(client) {
      return client.post('project_wa/deleteRecipient', { data: { projectId: projectId, recipientId: recipientId } });
    },
    projectId: projectId,
    recipientId: recipientId
  };
}

function deleteRecipientsGroup(projectId, groupId) {
  return {
    types: loadReducer.constantsByKey.deleteRecipientsGroup,
    promise: function promise(client) {
      return client.post('project_wa/deleteRecipientsOfGroup', { data: { projectId: projectId, groupId: groupId } });
    },
    projectId: projectId,
    groupId: groupId
  };
}

function clearRecipientsList() {
  return {
    type: CLEAR_RECIPIENTS_LIST
  };
}

function editProjectLinks(projectId, data) {
  return (0, _extends6.default)({
    types: loadReducer.constantsByKey.editLinks,
    promise: function promise(client) {
      return client.post('project_wa/updateLinks', { data: (0, _extends6.default)({ projectId: projectId }, data) });
    },
    projectId: projectId
  }, data);
}

function deleteCover(projectId) {
  return {
    types: loadReducer.constantsByKey.deleteCover,
    promise: function promise(client) {
      return client.post('project_wa/deleteCover', { data: { projectId: projectId } });
    },
    projectId: projectId
  };
}

function setCover(projectId, cover) {
  return {
    type: SET_COVER,
    projectId: projectId,
    cover: cover
  };
}

function testEmail(projectId) {
  return {
    types: loadReducer.constantsByKey.testEmail,
    promise: function promise(client) {
      return client.post('project_wa/sendTestEmail', { data: { projectId: projectId } });
    },
    projectId: projectId
  };
}

function sendEmail(projectId, sendType) {
  return {
    types: loadReducer.constantsByKey.sendEmail,
    promise: function promise(client) {
      return client.post('project_wa/setSendType', { data: { projectId: projectId, sendType: sendType } });
    },
    projectId: projectId,
    sendType: sendType
  };
}

function loadConfirmation(projectId) {
  return {
    types: loadReducer.constantsByKey.confirmation,
    promise: function promise(client) {
      return client.post('project_wa/getConfirmation', { data: { projectId: projectId } });
    },
    projectId: projectId
  };
}

function loadStatusInfo(projectId) {
  return {
    types: loadReducer.constantsByKey.statusInfo,
    promise: function promise(client) {
      return client.post('project_wa/getProjectStatusInfo', { data: { projectId: projectId } });
    },
    projectId: projectId
  };
}

function updateCoverStyle(projectId, coverStyle) {
  return {
    types: loadReducer.constantsByKey.updateCoverStyle,
    promise: function promise(client) {
      return client.post('project_wa/updateCoverStyle', { data: { projectId: projectId, coverStyle: coverStyle } });
    },
    projectId: projectId,
    coverStyle: coverStyle
  };
}

function addRecipientsFromContacts(projectId, contacts) {
  return {
    types: loadReducer.constantsByKey.addRecipientsFromContacts,
    promise: function promise(client) {
      return client.post('project_wa/addRecipientFromContacts', { data: { projectId: projectId, contacts: '[' + contacts.toString() + ']' } });
    },
    projectId: projectId,
    contacts: contacts
  };
}

function addRecipientsFromGroups(projectId, groups) {
  return {
    types: loadReducer.constantsByKey.addRecipientsFromGroups,
    promise: function promise(client) {
      return client.post('project_wa/addRecipientFromGroups', { data: { projectId: projectId, groups: '[' + groups.toString() + ']' } });
    },
    projectId: projectId,
    groups: groups
  };
}

function setMultipleBoxsets(projectId, multipleBoxsets) {
  return {
    types: loadReducer.constantsByKey.setMultipleBoxsets,
    promise: function promise(client) {
      return client.post('project_wa/updateMultipleBoxset', { data: { projectId: projectId, multipleBoxsets: multipleBoxsets } });
    },
    projectId: projectId,
    multipleBoxsets: multipleBoxsets
  };
}

function editRecipient(projectId, recipientId, data) {
  return (0, _extends6.default)({
    types: [EDIT_RECIPIENT, EDIT_RECIPIENT_SUCCESS, EDIT_RECIPIENT_FAIL],
    promise: function promise(client) {
      return client.post('project_wa/editRecipient', { data: (0, _extends6.default)({ projectId: projectId, recipientId: recipientId }, data) });
    },
    projectId: projectId,
    recipientId: recipientId
  }, data);
}

function loadTeamMembers(projectId) {
  return {
    types: loadReducer.constantsByKey.teamMembersList,
    promise: function promise(client) {
      return client.post('project_wa/listSharees', { data: { projectId: projectId } });
    },
    projectId: Number(projectId)
  };
}

function editTeamMember(projectId, shareeId, data) {
  return (0, _extends6.default)({
    types: loadReducer.constantsByKey.editTeamMember,
    promise: function promise(client) {
      return client.post('project_wa/editShareeMode', { data: (0, _extends6.default)({ projectId: projectId, shareeId: shareeId }, data) });
    },
    projectId: projectId,
    shareeId: shareeId
  }, data);
}

function deleteTeamMember(projectId, shareeId) {
  return {
    types: loadReducer.constantsByKey.deleteTeamMember,
    promise: function promise(client) {
      return client.post('project_wa/deleteSharee', { data: { projectId: projectId, shareeId: shareeId } });
    },
    projectId: projectId,
    shareeId: shareeId
  };
}

function loadUsersList(kw) {
  return {
    types: loadReducer.constantsByKey.usersList,
    promise: function promise(client) {
      return client.post('project_wa/getUsersList', { data: { kw: kw } });
    },
    kw: kw
  };
}

function addTeamMember(projectId, userId) {
  return {
    types: loadReducer.constantsByKey.addTeamMember,
    promise: function promise(client) {
      return client.post('project_wa/addSharee', { data: { projectId: projectId, userId: userId } });
    },
    projectId: projectId,
    userId: userId
  };
}

function loadSSProjects(projectId) {
  return {
    types: loadReducer.constantsByKey.ssProjectsList,
    promise: function promise(client) {
      return client.post('project_wa/listSharespaceProjects', { data: { projectId: projectId } });
    },
    projectId: projectId
  };
}

function deleteSSProject(projectId) {
  return {
    types: loadReducer.constantsByKey.deleteSSProject,
    promise: function promise(client) {
      return client.post('project_wa/deleteProject', { data: { projectId: projectId } });
    },
    projectId: projectId
  };
}

function canSuspendSharespace(projectId) {
  return {
    types: loadReducer.constantsByKey.canSuspendSharespace,
    promise: function promise(client) {
      return client.post('project_wa/canSuspendSharespace', { data: { projectId: projectId } });
    },
    projectId: projectId
  };
}

function canPublishSharespace(projectId) {
  return {
    types: loadReducer.constantsByKey.canPublishSharespace,
    promise: function promise(client) {
      return client.post('project_wa/canPublishSharespace', { data: { projectId: projectId } });
    },
    projectId: projectId
  };
}

function suspendSharespace(projectId) {
  return {
    types: loadReducer.constantsByKey.suspendSharespace,
    promise: function promise(client) {
      return client.post('project_wa/suspendSharespace', { data: { projectId: projectId } });
    },
    projectId: projectId
  };
}

function createSubproject(_ref) {
  var projectId = _ref.projectId,
      data = _ref.data,
      tracks = _ref.tracks,
      press = _ref.press;

  var postData = (0, _extends6.default)({
    projectId: projectId,
    music: '[' + tracks.toString() + ']',
    listPress: '[' + press.toString() + ']'
  }, data);
  return (0, _extends6.default)({
    types: loadReducer.constantsByKey.createSubproject,
    promise: function promise(client) {
      return client.post('project_wa/createSubproject', { data: postData });
    }
  }, postData);
}

function updateMediaOrder(projectId, ids) {
  return {
    types: loadReducer.constantsByKey.updateMediaOrder,
    promise: function promise(client) {
      return client.post('FileUpload_wa/reOrderUploads', { data: { projectId: projectId, uploadIds: '[' + ids.toString() + ']' } });
    },
    projectId: projectId,
    ids: ids
  };
}

function ssCreate() {
  return {
    types: loadReducer.constantsByKey.ssCreate,
    promise: function promise(client) {
      return client.post('project_wa/createSharespace');
    }
  };
}

function projectCreate() {
  return {
    types: loadReducer.constantsByKey.projectCreate,
    promise: function promise(client) {
      return client.post('project_wa/createMinimalProject');
    }
  };
}

function addSender(_ref2) {
  var projectId = _ref2.projectId,
      email = _ref2.email,
      name = _ref2.name,
      surname = _ref2.surname;

  var data = { email: email, name: name, surname: surname, projectId: projectId };
  return {
    types: loadReducer.constantsByKey.addSender,
    promise: function promise(client) {
      return client.post('project_wa/addSenderToProject', { data: data });
    }
  };
}

function deleteSender(_ref3) {
  var projectId = _ref3.projectId;

  var data = { projectId: projectId };
  return {
    types: loadReducer.constantsByKey.deleteSender,
    promise: function promise(client) {
      return client.post('project_wa/deleteSenderFromProject', { data: data });
    }
  };
}

function setRecipientsDownload(_ref4) {
  var projectId = _ref4.projectId,
      download = _ref4.download;

  var data = { projectId: projectId, download: Number(download) };
  return {
    types: loadReducer.constantsByKey.setRecipientsDownload,
    promise: function promise(client) {
      return client.post('project_wa/setAllRecipientsDownload', { data: data });
    },
    projectId: projectId,
    download: download
  };
}

function resortMediaList(dragIndex, hoverIndex) {
  return {
    type: RESORT_MEDIA_LIST,
    dragIndex: dragIndex,
    hoverIndex: hoverIndex
  };
}

function setCloudFileStatus(_ref5) {
  var uniqId = _ref5.uniqId,
      status = _ref5.status;

  return {
    type: SET_CLOUD_FILE_DATA,
    uniqId: uniqId,
    data: { status: status }
  };
}

function setCloudFileFailedStatus(uniqId) {
  return {
    type: SET_CLOUD_FILE_DATA,
    uniqId: uniqId,
    data: { status: 'failed' }
  };
}

function setCloudFileSuccessStatus(uniqId) {
  return {
    type: SET_CLOUD_FILE_DATA,
    uniqId: uniqId,
    data: { status: 'success' }
  };
}

function setCloudFileMetadata(_ref6) {
  var uniqId = _ref6.uniqId,
      metadata = _ref6.metadata;

  return {
    type: SET_CLOUD_FILE_DATA,
    uniqId: uniqId,
    data: { metadata: metadata }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/project.js
// module id = 37
// module chunks = 1